export const requiredMessage = 'Complete this required field.';

export function missingRequired(value: unknown): boolean {
  return value === undefined || value === null || String(value).trim() === '';
}

/** Validate only the active form, never another card or dialog on the page. */
export function validateRequiredFields(scope: Element | null): boolean {
  if (!scope) return true;
  const controls = Array.from(scope.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
    'input[required],select[required],textarea[required],input[aria-required="true"],select[aria-required="true"],textarea[aria-required="true"]',
  ));
  const invalid = controls.filter(control => {
    if (control.disabled || control.matches(':disabled') || control.getAttribute('aria-disabled') === 'true' || control.closest('[hidden],[inert],details:not([open])') || control.getClientRects().length === 0) return false;
    if (control instanceof HTMLInputElement && ['checkbox', 'radio'].includes(control.type)) return !control.checked;
    return missingRequired(control.value);
  });
  invalid.forEach(control => control.dispatchEvent(new Event('invalid', { cancelable: true, bubbles: false })));
  invalid[0]?.focus();
  return invalid.length === 0;
}

export function validateFromButton(button: HTMLElement): boolean {
  return validateRequiredFields(button.closest('[data-form-scope],form,[role="dialog"]'));
}
